/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_FaqInputs */

const en_footer_faq = /** @type {(inputs: Footer_FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQ`)
};

const lv_footer_faq = /** @type {(inputs: Footer_FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BUJ`)
};

/**
* | output |
* | --- |
* | "FAQ" |
*
* @param {Footer_FaqInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const footer_faq = /** @type {((inputs?: Footer_FaqInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_FaqInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_footer_faq(inputs)
	return en_footer_faq(inputs)
});